/**
 * Fork overlay (new file, no OSS equivalent) — PR-A1.
 * Client for the Meta broker connect handoff endpoint. Mints a signed handoff token and
 * returns the broker connect URL to redirect to (FB JS SDK can't run on tenant subdomains).
 */
/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class MetaConnectAPI extends ApiClient {
  constructor() {
    super('meta_connect', { accountScoped: true });
  }

  handoff({ mode, inboxId } = {}) {
    return axios.post(`${this.url}/handoff`, { mode, inbox_id: inboxId });
  }
}

export default new MetaConnectAPI();
